import { render, staticRenderFns } from "./LoginUpdated.vue?vue&type=template&id=857f0e48&scoped=true&"
import script from "./LoginUpdated.vue?vue&type=script&lang=js&"
export * from "./LoginUpdated.vue?vue&type=script&lang=js&"
import style0 from "./LoginUpdated.vue?vue&type=style&index=0&id=857f0e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f0e48",
  null
  
)

export default component.exports